import { FC } from "react";
import { PdfData } from "@/models/pdfData";
import OpenChallengeViewButton from "../OpenChallengeViewButton";
import OpenTabletViewButton from "../OpenTabletViewButton";
import DownloadPdfButton from "../DownloadPdfButton";
import DeleteGameButton from "../DeleteGameButton";
import { Stack } from "@mui/material";
import OpenScoreSheetButton from "../OpenScoreSheetButton";

const GameListButtons: FC<{ game: PdfData }> = ({ game }) => {
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"space-around"}>
      <OpenTabletViewButton storedGame={game} />
      <OpenChallengeViewButton storedGame={game} />
      <DownloadPdfButton game={game} />
      <OpenScoreSheetButton game={game} />
      <DeleteGameButton storedGame={game} />
    </Stack>
  );
};

export default GameListButtons;
